<template>
    <section>
        <div>
            <form @submit.prevent="changePassword" novalidate>
            <div class="t-body3 mgt-6 t-color-content1">
                {{$t('410')}}                
                <!-- 새로운 비밀번호를 입력하세요.<br>
                문자와 숫자를 조합하여 8자리 이상 입력 시 강력한 비밀 보호를 받으실 수 있습니다. -->
            </div>
            <div class="mgt-38">
                <input type="hidden"
                    v-model="findPw.password"
                    name="password"
                    ref="password"
                >
                <div class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full"
                    :class="submitState && passwordConfirmInvalidCheck ? 'mdc-text-field--invalid' : ''"
                    id="passwordConfirmEl"
                >
                    <i class="material-icons mdc-text-field__icon">
                        {{validIcon}}
                    </i>
                    <input type="password" class="mdc-text-field__input"
                        id="passwordConfirm"
                        name="passwordConfirm"
                        v-model="passwordConfirm"
                        v-validate="'required|confirmed:password'"
                        data-vv-as="password"
                        ref="passwordConfirm"
                    >
                    <div class="mdc-notched-outline">
                        <div class="mdc-notched-outline__leading"></div>
                        <div class="mdc-notched-outline__notch">
                        <label for="tf-outlined" class="mdc-floating-label">
                            {{$t('411')}}
                            <!-- 새 비밀번호 확인-->
                        </label>
                        </div>
                        <div class="mdc-notched-outline__trailing"></div>
                    </div>
                    
                </div>
                <div class="t-helper mgl-7 mgr-7 pdt-2 min-h-23"  :class="submitState && passwordConfirmInvalidCheck ? 't-color-red1' : ''">
                    <span>
                        {{$t('412')}}
                        <!-- * 동일한 비밀번호를 입력하세요. -->
                    </span>
                </div>
            </div>
            <div class="mgt-38">
                <button class="mdc-button mdc-button--raised btn-red">
                    {{$t('413')}}
                    <!-- 완료 -->
                </button>
                <button class="mdc-button btn-white mgr-8 mgl-8" @click="cancelFindPw()" type="button">
                    {{$t('414')}}
                    <!-- 취소 -->
                </button>
            </div>
            </form>
        </div>
    </section>

    
</template>

<script>
/**
 * 비밀번호 재설정 Step5 컴포넌트 (reset password Step5 component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTextField} from '@material/textfield'
import {MDCRipple} from '@material/ripple'
import findApi from '@/api/findApi.js'
import {mapState, mapMutations} from 'vuex'
import {findIdMixin} from '@/mixins/findId.js'

export default {
    data() {
        return {
            passwordConfirm: '',
            passwordConfirmTextField: null,
            submitState: false,
            validIcon: ''
        }
    },

    mixins: [findIdMixin],

    computed: {
        ...mapState('findPw',{
            findPw : state => state,
        }),

        // 패스워드 확인 유효성 체크(validation password confirm)
        passwordConfirmInvalidCheck() {
            let returnValue = false
            if (this.submitState) {
                if (this.errors.has('passwordConfirm')) {
                    returnValue = true
                    this.validIcon = 'warning'
                }else {
                    returnValue = false
                    this.validIcon = 'check'
                }
            }

            this.passwordConfirmTextField.valid === !returnValue ? '' : this.passwordConfirmTextField.valid = !returnValue
            return returnValue
        }
    },

    mounted() {
        // 토큰값이 없을 경우 Step1로 이동(If there is no token value, go to Step1)
        if (!this.findPw.step3.token) {
            this.$moveLogin()
        }

        this.setMaterialUi()
        this.$refs.passwordConfirm.focus()
    },

    methods: {
        
        // Store 변이 정의(define store mutation)
        ...mapMutations('findPw', ['INIT_FINDPW_STORE']),

        setMaterialUi() {
            this.passwordConfirmTextField = new MDCTextField(document.querySelector('#passwordConfirmEl'))
            this.passwordConfirmTextField.useNativeValidation = false

            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })
        },

        // 비밀번호 변경(reset password)
        changePassword() {
            this.$validator.validateAll().then((resultValid) => {
                this.submitState = true
                if (resultValid) {
                    let responseData = null

                    let params = {
                        token: this.findPw.step3.token,
                        value: this.findPw.certiNumber,
                        newPassword: this.findPw.password
                    }

                    findApi.changeFindPw(params).then((response) => {

                        responseData = response.data.data
                        if (responseData) {
                            this.$alert({
                                title: this.$t('421'), //비밀번호 변경 완료
                                content: this.$t('422') + ' ' +this.$t('415'), //새로운 비밀번호로 변경이 완료되었습니다. 다시 로그인해주세요.
                                accept:  this.$t('423'),
                            }).then(() => {
                                this.INIT_FINDPW_STORE()
                                this.$moveLogin()
                            })
                        } else{
                            this.$error({
                                // content: '비밀번호 변경중 오류가 발생했습니다.',
                                content: this.$t('957'),
                                accept:  this.$t('423'),
                            }).then(() => {this.$moveLogin()})
                        }

                    }).catch((err) => {
                        responseData = err.response.data.meta
                        this.$error({content: responseData.errMsg}).then(() => {this.$moveLogin()})
                    })
                }else {
                    this.$refs.passwordConfirm.focus()
                }
            })
        }

    },

}
</script>